const dotenv = () => ({
  apiBaseUrl: process.env.REACT_APP_BACKEND_URL
})

export default dotenv()
